import { Component, Input } from "@angular/core";

@Component({
	selector: "success-screen",
	templateUrl: "./success-screen.component.html",
	styleUrls: ["./success-screen.component.scss"],
	standalone: false
})
export class SuccessScreenComponent {
	@Input() public bgImage: string = ""; // CoinsCrypto || coinsFiat || '""

	public getBgCssClass(): string {
		let cssClass = "";

		switch (this.bgImage) {
			case "coinsFiat":
				cssClass = "mod-bg-fiat";
				break;
			default:
				cssClass = "";
				break;
		}

		return cssClass;
	}
}
